import { matchPath, useLocation } from 'react-router-dom';
function getPathname(to) {
  if (!to) {
    return '';
  }
  if (typeof to === 'string') {
    return to;
  }
  return to.pathname || '';
}
function useIsRouteActive(to) {
  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
    _ref$end = _ref.end,
    end = _ref$end === void 0 ? false : _ref$end;
  var location = useLocation();
  var toPathname = getPathname(to);
  return Boolean(toPathname && matchPath({
    path: toPathname,
    end: end
  }, location.pathname));
}
export default useIsRouteActive;